import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PartyProvider } from './contexts/PartyContext';
import { ToastProvider } from './contexts/ToastContext';
import ErrorBoundary from './components/ErrorBoundary';
import LandingPage from './pages/LandingPage';
import DashboardPage from './pages/DashboardPage';
import PartyPageRouter from './pages/PartyPageRouter';
import SearchPageRouter from './pages/SearchPageRouter';
// TODO: Implement JoinPartyPageRouter and SearchPageRouter for full split
import AdminPage from './pages/AdminPage';
import SubscriptionPage from './pages/SubscriptionPage';
import OAuthComplete from './pages/OAuthComplete';
import MobileFooter from './components/MobileFooter';
import WelcomeModal from './components/WelcomeModal';
import DebugOverlay from './components/DebugOverlay';
import AdminAdsPage from './pages/AdminAdsPage';
import InstructionsPage from './pages/InstructionsPage';
import CookieBanner from './components/CookieBanner';
import ContentSourcesPage from './pages/ContentSourcesPage';
import FeedbackPage from './pages/FeedbackPage';
import FarklePlaytestPage from './pages/FarklePlaytestPage';
import FarkleCrowdHostPage from './pages/FarkleCrowdHostPage';
import FarkleJoinPage from './pages/FarkleJoinPage';
import ImposterHostPage from './pages/ImposterHostPage';
import ImposterJoinPage from './pages/ImposterJoinPage';
import { reducedModeEnabled } from './utils/reducedMode';
import FeedbackFab from './components/FeedbackFab';
// import HostPage from './pages/Host';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <PartyProvider>
          <ToastProvider>
          <Router>
            <div className="min-h-screen">
              <WelcomeModal />
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/party/:partyId" element={<PartyPageRouter />} />
                <Route path="/party/:partyId/game/farkle" element={<FarkleCrowdHostPage />} />
                <Route path="/party/:partyId/game/farkle/join" element={<FarkleJoinPage />} />
                <Route path="/party/:partyId/game/farkle/playtest" element={<FarklePlaytestPage />} />
                <Route path="/party/:partyId/game/imposter" element={<ImposterHostPage />} />
                <Route path="/party/:partyId/game/imposter/join" element={<ImposterJoinPage />} />
                {/** Phone-host route removed to keep main branch only */}
                {/* /join/:partyId sends guests to the song-request page, not the host display */}
                <Route path="/join/:partyId" element={<SearchPageRouter />} />
                <Route path="/search/:partyId" element={<SearchPageRouter />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/admin/ads" element={<AdminAdsPage />} />
                <Route path="/instructions" element={<InstructionsPage />} />
                <Route path="/content-sources" element={<ContentSourcesPage />} />
                <Route path="/feedback" element={<FeedbackPage />} />
                <Route path="/subscription" element={<SubscriptionPage />} />
                <Route path="/oauth-complete" element={<OAuthComplete />} />
                {/* <Route path="/host/:partyId" element={<HostPage />} /> */}
              </Routes>
              {reducedModeEnabled && <FeedbackFab />}
              <MobileFooter />
              <CookieBanner />
              <DebugOverlay />
            </div>
          </Router>
          </ToastProvider>
        </PartyProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;